
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Table, InjectFunction } from "@common/src/utils/decorator";
import { namespace } from "vuex-class";

const base = namespace("base");
const marketing = namespace("marketing");

@InjectFunction(
  "dayjs",
  "emptyToLine",
  "splitThousands",
  "permit",
  "permitApp",
  "appCode",
  "addCurrencySymbol",
  "addCurrencyUnit"
)
@Component({})
@Table("loadListData")
export default class CardConsumeDialog extends Vue {
  @base.Action getDictionaryList;
  @marketing.Action queryPreDepositDetail;
  @Prop({ default: () => ({}), type: Object })
  cardData: any;
  @Prop({ default: () => ({}), type: Object })
  searchParams: any;
  showDetail = false;
  operateTypeList = [];
  created() {
    this.getDictionaryList("card_report_transaction_type").then(data => {
      this.operateTypeList = data;
    });
  }
  listData = [];
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryPreDepositDetail({
      // ...this.searchForm,
      ...this.searchParams,
      cardCode: this.cardData.cardCode,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.listData = data?.data || [];
      return data;
    });
  }
  open() {
    this.showDetail = true;
  }
  @Watch("cardData")
  cardCodeChange() {
    this.loadListData();
  }
  handleToPaymentDetail(row) {
    if (row.businessNo.includes("SK")) {
      window.open(this.$router.resolve(`/finance/collection-order-view/${row.businessNo}`).href);
    } else {
      window.open(this.$router.resolve(`/finance/payment-order-view/${row.businessNo}`).href);
    }
  }
}
